import React from "react";
import PropTypes from "prop-types";
import style from "./WmsCustomDateTimePickerProto.scss";

// React requires an onChange handler on a controlled select to avoid a dev-mode
// warning; real change handling is done via a native listener (see setTimeSelectRef)
// so this stays a no-op.
const NOOP = () => void (0);

class WmsCustomDateTimePickerProto extends React.PureComponent {
    constructor(props) {
        super(props);
        this.windowId = this.props.windowId == "" ? "" : "." + this.props.windowId;
        this.clearerElement = null;
        this.timeSelectElement = null;

        this.defaultDateOption = {
            date: '',
            time: ''
        };
        this.defaultTimeFormat = 'h:mma';
        this.defaultDateTime = moment(this.props.defaultTime, 'HH:mm:ss');

        this.state = {
            timeOptions: [],
            filterString: this.props.value,
            selectedDateOptions: this.defaultDateOption,
        };
    }

    // Native listeners: React synthetic clicks can miss after Kendo reparents the DOM.
    setClearerRef = (element) => {
        if (this.clearerElement === element) {
            return;
        }

        if (this.clearerElement) {
            this.clearerElement.removeEventListener("click", this.clearDatePicker);
        }

        this.clearerElement = element;

        if (this.clearerElement) {
            this.clearerElement.addEventListener("click", this.clearDatePicker);
        }
    }

    // The time select goes the same way as the clearer: when a Kendo window moves
    // this picker to #root the tree it mounted into no longer receives its change
    // events, so listen for them on the element instead of through React.
    setTimeSelectRef = (element) => {
        if (this.timeSelectElement === element) {
            return;
        }

        if (this.timeSelectElement) {
            this.timeSelectElement.removeEventListener("change", this.changeTime);
        }

        this.timeSelectElement = element;

        if (this.timeSelectElement) {
            this.timeSelectElement.addEventListener("change", this.changeTime);
        }
    }

    componentDidMount() {

        $(`${this.windowId} #${this.props.id}-date-input`).kendoDatePicker({
            change: this.changeDate,
        });
        $(`${this.windowId} #${this.props.id}-date-input`).bind("focus", (e) => {
            let datePicker = $(`${this.windowId} #${this.props.id}-date-input`).data("kendoDatePicker");
            datePicker.open();
        });
        if (!this.props.onlyDate) {
            this.setOptionsForTime(this.props.stepsTime);
        }
    }

    componentWillUnmount() {
        if (this.clearerElement) {
            this.clearerElement.removeEventListener("click", this.clearDatePicker);
        }

        if (this.timeSelectElement) {
            this.timeSelectElement.removeEventListener("change", this.changeTime);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value != prevProps.value) {
            this.setDateTimePickerValue(this.props.value);
        }
    }

    setDateTimePickerValue = (filterString) => {
        // Treat null/undefined/'' as empty. moment(null)/moment(undefined) resolve to
        // "now", which would wrongly populate today when the field is cleared or unset.
        let momentDate = filterString ? moment(filterString) : null;
        if (momentDate && momentDate.isValid()) {
            let propsDate = momentDate.format();
            let propsTime = momentDate.format(this.defaultTimeFormat);

            this.changeSelectedDateOptions({
                date: propsDate,
                time: propsTime
            }, false);
        } else {
            this.changeSelectedDateOptions(this.defaultDateOption, false, true);
        }

    }

    changeDate = () => {
        let datepicker = $(`${this.windowId} #${this.props.id}-date-input`).data("kendoDatePicker");
        this.changeSelectedDateOptions({ date: datepicker.value() });
    }

    changeTime = (event) => {
        let time = event.target.value;
        let selectedOpt = { time: time };
        if (time && !this.state.selectedDateOptions.date) {
            selectedOpt.date = moment().format();
        }
        this.changeSelectedDateOptions(selectedOpt);
    }

    changeSelectedDateOptions = (updateObj, emitAfterUpdate = true, clearTime = false) => {
        let selectedOptions = Object.assign({}, this.state.selectedDateOptions, updateObj);
        if(!clearTime) {
            selectedOptions.time = (selectedOptions.time) ? selectedOptions.time : this.defaultDateTime.format(this.defaultTimeFormat);
        }

        // Backfill today's date when a time is chosen but no date is set, so the
        // picker matches the Routing Pickup Date/Time behavior.
        if (!selectedOptions.date && selectedOptions.time) {
            selectedOptions.date = moment().format();
        }

        let datepicker = $(`${this.windowId}  #${this.props.id}-date-input`).data("kendoDatePicker");
        // Kendo's datePicker only renders Date objects; a moment ISO string is
        // silently ignored and leaves the input visually empty.
        let kendoDateValue = selectedOptions.date ? moment(selectedOptions.date).toDate() : null;
        datepicker.value(kendoDateValue);

        this.setState({
            selectedDateOptions: selectedOptions,
        }, () => {
            if (emitAfterUpdate) {
                this.changeDateTimeAndEmit();
            }
        });
    }

    changeDateTimeAndEmit = () => {
        let {date, time} = this.state.selectedDateOptions;
        let filterString = '';

        // Only fall back to today when a time is present (time-only entry). When both
        // date and time are empty (e.g. after clicking the clear button) stay empty
        // so clearing emits '' instead of resurrecting today's date.
        let momentDate = date ? moment(date) : null;

        if ((!momentDate || !momentDate.isValid()) && time) {
            momentDate = moment();
        }

        if (momentDate && momentDate.isValid()) {
            if (time) {
                let dateTime = moment(time, this.defaultTimeFormat);
                if (dateTime.isValid()) {
                    momentDate.set({
                        hour: dateTime.get('hours'),
                        minute: dateTime.get('minute'),
                        second:1,
                        millisecond:0
                    });
                }
            }
            if(!this.props.isDateParseInCustomFormat){
                momentDate = momentDate.utc();
            }

            filterString = (this.props.isDateParseInCustomFormat) ? momentDate.format('YYYY-MM-DDTHH:mm:ss') : momentDate.toISOString();
        }

        this.setState({
            filterString: filterString
        });

        let eventObj = {
            target:{
                name: this.props.name,
                value: filterString,
            }
        }

        this.props.onChangeFunc(eventObj);
    }

    setOptionsForTime = (step = 60) => {
        let timeArray = [];
        let minute = 0;
        let totMinutes = moment.duration(1, "day").asMinutes();

        while (minute <= totMinutes) {
            let time = moment.utc(moment.duration(minute, "minutes").asMilliseconds()).format(this.defaultTimeFormat);
            timeArray.push(time);
            if (minute == (totMinutes - step)) {
                step--;
            }
            minute += step;
        }
        this.setState({
            timeOptions: timeArray,
        });
    }

    clearDatePicker = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.state.selectedDateOptions.date != "" || this.state.selectedDateOptions.time != "") {
            let dateOptions = this.defaultDateOption;
            this.changeSelectedDateOptions(dateOptions, true, true);
            const datePicker = $(`${this.windowId} #${this.props.id}-date-input`).data("kendoDatePicker");
            if (datePicker) {
                datePicker.value(null);
            }
        }
    }

    render() {
        return (
            <div
                id={this.props.id}
                className="wms-datetimepicker-component-proto-kendo"
                data-wms-selector={this.props.wmsSelector}
            >
                <label>{this.props.label} </label>
                <div
                    className={`border ${(this.props.disabled) ? 'dropdown-disabled' : ''} ${this.props.parentClassName}`}
                >
                    <div className="datePicker_options">
                        <div className={`wms-DatePicker-main`}>
                            <input id={`${this.props.id}-date-input`} name='date' />
                        </div>

                        {!this.props.onlyDate && (
                            <div className={`wms-DatePicker-main`}>
                                <select
                                    ref={this.setTimeSelectRef}
                                    name="time"
                                    onChange={NOOP}
                                    value={this.state.selectedDateOptions.time != null ? this.state.selectedDateOptions.time : ''}
                                >
                                    {(this.state.selectedDateOptions.time == '') &&
                                        <option value="">--:--</option>
                                    }
                                    {this.state.timeOptions.map((time, key) => (
                                        <option value={time} key={key}>{time}</option>
                                    ))}
                                </select>
                                <span className="caret"></span>
                            </div>
                        )}
                    </div>
                    <div
                        ref={this.setClearerRef}
                        className="datePicker_clearer"
                        role="button"
                        tabIndex={0}
                        aria-label="Clear date"
                    ><i className="fa fa-times-circle-o" aria-hidden="true"></i></div>
                </div>
            </div>
        );
    }
}

WmsCustomDateTimePickerProto.propTypes = {
  id: PropTypes.string.isRequired, // this should write the id to the input
  name: PropTypes.string.isRequired, //this should set the name of datepicker input
  label: PropTypes.string.isRequired, // this should write the label of the menu
  windowId: PropTypes.string, // this should be used to get window id
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]), // this should control the value of datepicker
  defaultTime: PropTypes.string, // this is used for set default time of datetimepicker
  stepsTime: PropTypes.number, // this is used for set steps in times dropdown
  onChangeFunc: PropTypes.func.isRequired, // this sould manage datepicker change and clear select value
  parentClassName: PropTypes.string, //    this should parent tag class default parent class is form-group
  onlyDate: PropTypes.bool, // hide time icon for only show date
  wmsSelector: PropTypes.string, // this should set up a selector on the date
  disabled: PropTypes.bool,  // default will be false
  isDateParseInCustomFormat: PropTypes.bool,  // set true to parse date in custom format not in ISO
};

WmsCustomDateTimePickerProto.defaultProps = {
  defaultTime: "00:00:01",
  stepsTime: 30,
  parentClassName: "",
  windowId: "",
  onlyDate: false,
  disabled: false,
  wmsSelector: "",
  isDateParseInCustomFormat:false,
};

export default WmsCustomDateTimePickerProto;
